<script>
import { FileService } from '@/services'
import { useEvidence } from '@/use/evidence'

import { FileUpload } from '@/components/page/file-upload'
import {
  FilePreviewList,
  FilePreviewListItem,
  FilePreview
} from '@/components/page/file-preview'

export default {
  model: {
    event: 'change'
  },

  props: {
    value: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      isUploading: false
    }
  },

  methods: {
    addEvidence(value) {
      this.$emit('change', [...this.value, value])
    },

    removeEvidence(index) {
      this.$emit(
        'change',
        this.value.filter((item, itemIndex) => itemIndex !== index)
      )
    },

    async handleFileChange(files) {
      this.isUploading = true

      const promises = files
        .filter(file => {
          if (!/^image\/.+|application\/pdf$/.test(file.type)) {
            this.$message.warning(`${file.name} ไม่สามารถอัปโหลดได้`)
            return false
          }
          return true
        })
        .map(
          async file =>
            await FileService.create(file)
              .then(res => res.data)
              .then(({ status, result }) => {
                if (status === 'error') {
                  throw new Error(`${file.name} มีปัญหาในการอัปโหลด`)
                }

                return result
              })
              .then(({ id, attachment }) => {
                this.addEvidence(useEvidence({ id, url: attachment }))

                this.$message.success(`อัปโหลด ${file.name} เรียบร้อยแล้ว`)
              })
              .catch(err => {
                this.$message.error(err.message)
              })
        )

      await Promise.all(promises)

      this.isUploading = false
    }
  },

  render() {
    return (
      <div>
        <h2>แนบหลักฐาน/สลิป</h2>
        <FileUpload
          uploading={this.isUploading}
          style={{ marginBottom: '1rem' }}
          onChange={this.handleFileChange}
        />
        <FilePreviewList>
          {this.value.map((item, index) => (
            <FilePreviewListItem key={index}>
              <FilePreview
                src={item.url}
                style={{ width: '150px', height: '150px' }}
                onRemove={() => {
                  this.removeEvidence(index)
                }}
              />
            </FilePreviewListItem>
          ))}
        </FilePreviewList>
      </div>
    )
  }
}
</script>
